import api from './apiClient';

// ─── KULLANICILAR ────────────────────────────────────────────────────────────

export const getUsers = async () => {
  const response = await api.get('/Admin/users');
  return response.data;
};

export const createUser = async (email, fullName, reportGroupIds = [], tenantId = null) => {
  const response = await api.post('/Admin/users', { email, fullName, reportGroupIds, tenantId });
  return response.data;
};

export const deactivateUser = async (userId) => {
  const response = await api.delete(`/Admin/users/${userId}`);
  return response.data;
};

export const toggleCanAccessTest = async (userId) => {
  const response = await api.patch(`/Admin/users/${userId}/can-access-test`);
  return response.data;
};

// ─── RAPOR GRUPLARI ──────────────────────────────────────────────────────────

export const getAdminReportGroups = async () => {
  const response = await api.get('/Admin/report-groups');
  return response.data;
};

export const createReportGroup = async (name, description, tenantId = null, environment = 'prod', aiChatEnabled = true) => {
  const response = await api.post('/Admin/report-groups', { name, description, tenantId, environment, aiChatEnabled });
  return response.data;
};

export const addReportToGroup = async (groupId, reportId) => {
  const response = await api.post(`/Admin/report-groups/${groupId}/reports/${reportId}`);
  return response.data;
};

export const removeReportFromGroup = async (groupId, reportId) => {
  const response = await api.delete(`/Admin/report-groups/${groupId}/reports/${reportId}`);
  return response.data;
};

// ─── RAPORLAR ────────────────────────────────────────────────────────────────

export const getAdminReports = async () => {
  const response = await api.get('/Admin/reports');
  return response.data;
};

export const createReport = async (name, powerBiReportId, description, environment, workspaceId, tenantId = null) => {
  const response = await api.post('/Admin/reports', { name, powerBiReportId, description, environment, workspaceId, tenantId });
  return response.data;
};

export const getPowerBiReports = async (environment = 'prod', tenantId = null) => {
  const params = new URLSearchParams({ environment });
  if (tenantId) params.append('tenantId', tenantId);
  const response = await api.get(`/Admin/powerbi-reports?${params.toString()}`);
  return response.data;
};

// ─── KULLANICI - GRUP İLİŞKİSİ ───────────────────────────────────────────────

export const addUserToGroup = async (userId, groupId) => {
  const response = await api.post(`/Admin/users/${userId}/report-groups/${groupId}`);
  return response.data;
};

export const removeUserFromGroup = async (userId, groupId) => {
  const response = await api.delete(`/Admin/users/${userId}/report-groups/${groupId}`);
  return response.data;
};

// ─── AI MODELLER (REPORT CONTEXTS) ───────────────────────────────────────────

export const getReportContexts = async () => {
  const response = await api.get('/Admin/report-contexts');
  return response.data;
};

export const getReportContext = async (id) => {
  const response = await api.get(`/Admin/report-contexts/${id}`);
  return response.data;
};

export const createReportContext = async (name, dimensionDefinitions, measureDefinitions, systemPromptRules = '') => {
  const response = await api.post('/Admin/report-contexts', { name, dimensionDefinitions, measureDefinitions, systemPromptRules });
  return response.data;
};

export const updateReportContext = async (id, name, dimensionDefinitions, measureDefinitions, systemPromptRules = '') => {
  const response = await api.put(`/Admin/report-contexts/${id}`, { name, dimensionDefinitions, measureDefinitions, systemPromptRules });
  return response.data;
};

export const deleteReportContext = async (id) => {
  const response = await api.delete(`/Admin/report-contexts/${id}`);
  return response.data;
};

export const assignContextToReport = async (reportId, contextId) => {
  const response = await api.patch(`/Admin/reports/${reportId}/context/${contextId}`);
  return response.data;
};

// ─── TENANT YÖNETİMİ ─────────────────────────────────────────────────────────

export const getTenants = async () => {
  const response = await api.get('/Tenant');
  return response.data;
};

export const createTenant = async (
  name, description, powerBiWorkspaceId, powerBiTestWorkspaceId = null,
  primaryColor = null, secondaryColor = null, logoUrl = null, faviconUrl = null, portalTitle = null
) => {
  const response = await api.post('/Tenant', {
    name, description, powerBiWorkspaceId, powerBiTestWorkspaceId,
    primaryColor, secondaryColor, logoUrl, faviconUrl, portalTitle
  });
  return response.data;
};

export const updateTenant = async (
  id, name, description, powerBiWorkspaceId, powerBiTestWorkspaceId = null,
  primaryColor = null, secondaryColor = null, logoUrl = null, faviconUrl = null, portalTitle = null
) => {
  const response = await api.put(`/Tenant/${id}`, {
    name, description, powerBiWorkspaceId, powerBiTestWorkspaceId,
    primaryColor, secondaryColor, logoUrl, faviconUrl, portalTitle
  });
  return response.data;
};

export const toggleTenant = async (id) => {
  const response = await api.patch(`/Tenant/${id}/toggle`);
  return response.data;
};

export const deleteTenant = async (id) => {
  const response = await api.delete(`/Tenant/${id}`);
  return response.data;
};

// ─── MASTER DATA ─────────────────────────────────────────────────────────────
// Tüm fonksiyonlar axios api client kullanıyor.
// Token yönetimi, 401 refresh, error handling otomatik olarak apiClient.js'de.

// Ekipler
export const getTeams = async (tenantId) => {
  const response = await api.get(`/MasterData/teams?tenantId=${tenantId}`);
  return response.data;
};

export const createTeam = async (teamName, tenantId) => {
  const response = await api.post('/MasterData/teams', { tenantId, teamName });
  return response.data;
};

export const updateTeam = async (id, teamName, tenantId) => {
  const response = await api.put(`/MasterData/teams/${id}`, { tenantId, teamName });
  return response.data;
};

export const deleteTeam = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/teams/${id}?tenantId=${tenantId}`);
  return response.data;
};

// Bölgeler
export const getRegions = async (tenantId) => {
  const response = await api.get(`/MasterData/regions?tenantId=${tenantId}`);
  return response.data;
};

export const createRegion = async (regionName, teamId, tenantId) => {
  const response = await api.post('/MasterData/regions', { tenantId, regionName, teamId });
  return response.data;
};

export const deleteRegion = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/regions/${id}?tenantId=${tenantId}`);
  return response.data;
};

// Temsilciler
export const getReps = async (tenantId) => {
  const response = await api.get(`/MasterData/reps?tenantId=${tenantId}`);
  return response.data;
};

export const createRep = async (repName, repCode, regionId, tenantId) => {
  const response = await api.post('/MasterData/reps', { tenantId, repName, repCode, regionId });
  return response.data;
};

export const deleteRep = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/reps/${id}?tenantId=${tenantId}`);
  return response.data;
};

// Brick Atamaları
export const getRepBricks = async (tenantId) => {
  const response = await api.get(`/MasterData/rep-bricks?tenantId=${tenantId}`);
  return response.data;
};

export const closeRepBrick = async (id, endDate, tenantId) => {
  const response = await api.patch(`/MasterData/rep-bricks/${id}/close`, { tenantId, endDate });
  return response.data;
};

export const deleteRepBrick = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/rep-bricks/${id}?tenantId=${tenantId}`);
  return response.data;
};

export const createRepBrick = async (data, tenantId) => {
  const response = await api.post('/MasterData/rep-bricks', { tenantId, ...data });
  return response.data;
};

// Pazarlar
export const getMarkets = async (tenantId) => {
  const response = await api.get(`/MasterData/markets?tenantId=${tenantId}`);
  return response.data;
};

export const createMarket = async (marketName, teamId, tenantId) => {
  const response = await api.post('/MasterData/markets', { tenantId, marketName, teamId });
  return response.data;
};

export const updateMarket = async (id, marketName, teamId, tenantId) => {
  const response = await api.put(`/MasterData/markets/${id}`, { tenantId, marketName, teamId });
  return response.data;
};

export const deleteMarket = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/markets/${id}?tenantId=${tenantId}`);
  return response.data;
};

// Ürünler
export const getProducts = async (tenantId) => {
  const response = await api.get(`/MasterData/products?tenantId=${tenantId}`);
  return response.data;
};

export const bulkUpdateProducts = async (products, tenantId) => {
  const response = await api.put('/MasterData/products/bulk-update', { tenantId, products });
  return response.data;
};

export const assignProductToMarket = async (productId, marketId, tenantId) => {
  const response = await api.post(`/MasterData/products/${productId}/markets/${marketId}`, { tenantId });
  return response.data;
};

export const removeProductFromMarket = async (productId, marketId, tenantId) => {
  const response = await api.delete(`/MasterData/products/${productId}/markets/${marketId}?tenantId=${tenantId}`);
  return response.data;
};

// Coğrafya
export const getGeography = async (tenantId) => {
  const response = await api.get(`/MasterData/geography?tenantId=${tenantId}`);
  return response.data;
};

export const closeAndReassign = async (id, data, tenantId) => {
  const response = await api.post(`/MasterData/rep-bricks/${id}/close-and-reassign`, { tenantId, ...data });
  return response.data;
};

// ─── BULK IMPORT ─────────────────────────────────────────────────────────────
// multipart/form-data — axios ile gönderilir.
// Content-Type header'ı axios tarafından otomatik set edilir (boundary dahil).
// Token apiClient interceptor'ı tarafından otomatik eklenir.

export const bulkImportSalesForce = async (file, tenantId) => {
  const formData = new FormData();
  if (tenantId) formData.append('tenantId', tenantId);
  formData.append('file', file);
  const response = await api.post('/MasterData/salesforce/bulk-import', formData);
  return response.data;
};

export const bulkImportProductsMarkets = async (file, tenantId) => {
  const formData = new FormData();
  if (tenantId) formData.append('tenantId', tenantId);
  formData.append('file', file);
  const response = await api.post('/MasterData/products-markets/bulk-import', formData);
  return response.data;
};